import { useQuery } from "@tanstack/react-query";
import calendarEventApiClient, {
  CalendarEvent,
  GetCalendarEventInput,
  PopulatedCalendarEvent,
} from "../../../api/calendarEvent";

const normalizeParams = (params: GetCalendarEventInput) => {
  return {
    country: params.country || undefined,
    year: params.year,
    month: params.month || undefined,
    day: params.day || undefined,
    state: params.state || undefined,
    populated: params.populated,
  };
};

const createCalendarEventsQueryKey = (params: GetCalendarEventInput) => {
  const normalized = normalizeParams(params);
  return [
    "calendar-events",
    normalized.country,
    normalized.year,
    normalized.month,
    normalized.day,
    normalized.state,
    normalized.populated,
  ].filter((param) => param !== undefined);
};

const useCalendarEvents = ({
  country,
  year,
  month,
  day,
  state,
  populated,
  enabled = true,
}: GetCalendarEventInput & { enabled?: boolean }) => {
  const normalizedParams = normalizeParams({
    country,
    year,
    month,
    day,
    state,
    populated,
  });
  const queryKey = createCalendarEventsQueryKey(normalizedParams);

  return useQuery<CalendarEvent[] | PopulatedCalendarEvent[]>({
    queryKey,
    queryFn: async () => {
      return await calendarEventApiClient.getCalendarEvents(normalizedParams);
    },
    enabled: enabled && !!normalizedParams.year,
    retry: 1,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export default useCalendarEvents;
